// extracted by mini-css-extract-plugin
export default {"text-align-left":"text-align-left__rSneg","icon-class":"icon-class__gc-CM","card":"card__zCtn+"};